import { ObjectType } from '../types.js';
import { SchemaError } from '../errors/SchemaError.js';
export class PropertyPathParser {
    constructor(schema) {
        this.schema = schema;
    }
    parsePropertyType(path, type, external) {
        const pathFragments = path.split('.');
        let currentType = type;
        let propertyType;
        pathFragments.forEach(fragment => {
            if (fragment === '_id') {
                propertyType = 'string';
            }
            else {
                if (currentType instanceof ObjectType) {
                    const property = currentType.properties.find(prop => prop.name === fragment);
                    if (property) {
                        propertyType = property.type;
                    }
                    else {
                        const externalProperty = currentType.externals.find(e => e.name === fragment);
                        if (externalProperty) {
                            propertyType = externalProperty.type;
                        }
                    }
                }
            }
            if (!propertyType) {
                throw SchemaError.invalidExternalPropertyPath(path, `"${type.name}" of "${external.name}" external field. Check "${fragment}" property`);
            }
            currentType = this.schema.getType(propertyType);
        });
        return currentType;
    }
}
//# sourceMappingURL=PropertyPathParser.js.map